













































































































































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { NormsServices } from '../api/NormsServices';
import CreateDatabaseFileDialog from '../components/CreateDatabaseFileDialog.vue';
import { PageTitle } from '../../core/components';
import { generateZipFile } from '../index';
import { convertDictionaryToList, excludeIdFromList, formatList, getIndexFromList, getListWithNewItem } from '../../core/utils';
import Input from '../../core/components/Input.vue'; 
import Combobox from '../../core/components/Combobox.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 
import MultipleSelect from '../../core/components/MultipleSelect.vue'; 
import { PatchDatabase } from '../models/Database';
import { defaultSelectedOption, getListComboboxFormat } from '../../core/models/Combobox';

@Component({
    components: { 
        CreateDatabaseFileDialog, 
        PageTitle, 
        Input,
        Combobox,
        SimpleTable,
        MultipleSelect
    }
})
export default class NormasDatabaseList extends Mixins(CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper) {
    sortBy: string[] = ['id'];
    sortDesc: boolean[] = [true];
    showModalCreateDatabase: boolean = false;
    pendingRequest: boolean = false;
    pendingRequestFilterOptions: boolean = false;
    search: string = '';
    databaseDescription: string = '';
    headers: any[] = [
        {
            text: 'ID',
            align: 'center',
            value: 'id',
            width: '100px'
        },
        {
            text: 'Descripción',
            align: 'left',
            value: 'description'
        },
        {
            text: 'ECUs',
            align: 'left',
            value: 'ecus',
            formatter: (value) => formatList(value),
            filter: this.filterByEcu
        },
        {
            text: 'Protocolos',
            align: 'left',
            value: 'protocols',
            formatter: (value) => formatList(value),
            filter: this.filterByProtocol
        },
        {
            text: 'Medición',
            align: 'left',
            value: 'measures',
            formatter: (value) => formatList(value)
        },
        {
            text: 'Marca',
            align: 'left',
            value: 'brand',
            width: '200px',
            formatter: this.formatBrand,
            filter: this.filterByBrand
        },
        {
            text: 'Vehículos con norma activa',
            align: 'center',
            value: 'active_vehicles',
            width: '200px'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            sortable: false,
            width: '250px'
        }
    ];
    databaseRowToEdit: number = -1;
    defaultEditedItem: object = {
        id: 0,
        description: ''
    };
    editedItem: object = this.defaultEditedItem;
    items: any = [];
    pagination: object = {
        rowsPerPageItems: 18
    };
    customDatabaseData: any | null = null;
    previewDatabaseData: any | null = null;
    dbToDelete: number = -1;
    showDeleteConfirmationDialog: boolean = false;
    deleteConfirmationTitle: string = 'Eliminar archivo Database';
    deleteConfirmationMessage: string =
        '¿Está seguro que desea eliminar este archivo? Ésta acción no se podrá deshacer.';
    brandOptions: any[] = [];
    protocolOptions: any[] = [];
    ecusOptions:Array<defaultSelectedOption> = [];
    filteredEcus: Array<defaultSelectedOption> = [];
    ecuSelected: defaultSelectedOption | null = null;
    brandSelected: any = null;
    brandResetValue: any = null;
    protocolSelected: null | object = null;
    protocolSelectedRV: null | object = null;

    handleSelectECU(ecuToAdd){
        this.filteredEcus.push(ecuToAdd);
    }

    handleRemoveECU(ecuToRemove){
        this.filteredEcus = this.filteredEcus.filter(ecu => ecu.id !== ecuToRemove.id);
    }

    updateProtocolSelected(value){
        this.protocolSelected = value
    }

    updateProtocolSelectedRV(value){
        this.protocolSelectedRV = value;
    }

    customFilter(items, search, filter) {
        let userSearch = search.toString().toLowerCase();

        let filterDescription = filter['description'].toLowerCase();
        let filterId = filter['id'];
        let filterMeasures = filter['measures'];

        return filterDescription.includes(userSearch) || 
               filterId.toString().includes(userSearch) || 
               (filterMeasures.length > 0 && filterMeasures.some(measure => measure.toLowerCase().includes(userSearch)))
    }

    updateBrandSelected(value) {
        this.brandSelected = value;
    }
    updateBrandResetValue(value) {
        this.brandResetValue = value;
    }

    mounted() {
        this.getListDatabase();

        this.$nextTick(() => {
            this.protocolOptions = convertDictionaryToList(this.$_getNormsProperties['all_protocols']);
        })
    }

    filterByBrand(value) {
        if(this.brandSelected == null){
            return true;
        }
        return value == Number(this.brandSelected['id']);
    }

    filterByProtocol(value) {
        if(this.protocolSelected == null){
            return true;
        }
        return value.includes(this.protocolSelected['value']);
    }

    filterByEcu(ecusList: string[]){
        if(this.filteredEcus.length == 0){
            return true;
        }

        let parsedFilteredEcus = this.filteredEcus.map(ecu => ecu.value);
        let biggerEcusList = ecusList.length > parsedFilteredEcus.length ? ecusList : parsedFilteredEcus;
        let smallerEcusList = ecusList.length > parsedFilteredEcus.length ? parsedFilteredEcus : ecusList;

        let result = smallerEcusList.every((filteredEcu) => {
            return biggerEcusList.some((ecu) => {
                return filteredEcu === ecu;
            });
        });

        return result;
    }

    @Watch('$_getNormsProperties', { immediate: true, deep: true })
    onGetNormsPropertiesChanged(value) {
        this.brandOptions = convertDictionaryToList(value['all_brands']);
        this.protocolOptions = convertDictionaryToList(value['all_protocols']);
    }


    formatBrand(value) {
        return this.$_getNormsProperties['all_brands'][value] || value;
    }

    updateSearchValue(value){
        this.search = value;
    }

    closeDeleteConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.pendingRequest = true;
            NormsServices.deleteDatabaseById(this.dbToDelete)
                .then(response => {
                    this.items = excludeIdFromList(this.items, this.dbToDelete);
                    this.successLoadingDialog(response);
                })
                .catch(error => {
                    this.catchLoadingDialog(error);
                });
        }
        this.showDeleteConfirmationDialog = false;
    }

    trucate(value, length = 200) {
        return value.length <= length ? value : value.substring(0, length) + '...';
    }

    addNewFile(file) {
        this.pendingRequest = true;
        this.items = getListWithNewItem(this.items, file);
        this.pendingRequest = false;
    }

    getListDatabase() {
        this.pendingRequest = true;
        NormsServices.getDatabaseList(Axios.CancelToken.source())
            .then(res => {
                let normsList = res.databases;
                let ecusList = res.ecus;
                this.ecusOptions = getListComboboxFormat(ecusList);
                this.items = normsList.map(function(item, index){
                    return {
                        ...item,
                        disableDelete: item['active_vehicles'] > 0 ? true : false
                    }
                });
                this.pendingRequest = false;
            })
            .catch(error => {
                this.pendingRequest = false;
            });
    }

    successLoadingDialog(response){
        let self = this;
        if (response && response.data && response.data.message) {
            self.$_successDeleteRecipients(response['data']['message']);
        } else {
            self.$_successDeleteRecipients('Archivo eliminado con éxito');
        }
        self.pendingRequest = false;
    }

    catchLoadingDialog(error){
        if (error && error.response && error.response.data && error.response.data.message) {
                this.$_errorPatchRecipients(error.response.data.message);
        } else {
            this.$_errorPatchRecipients('No se pudo eliminar el archivo');
        }
        this.pendingRequest = false;
    }

    downloadDatabase(row){
        this.downloadFile(row, row['id'], row['description'])
    }

    downloadFile(item, fileId, fileDescription) {
        let self = this;
        this.$set(item, 'isDownloading', true);
        NormsServices.getDatabaseFiles(fileId)
            .then(response => {
                let folderName = response['id'] + '-' + fileDescription + '.zip';
                let databaseFile = response['database_txt'];
                let namesFile = response['names_txt'];
                if (databaseFile !== null && namesFile !== null) {
                    let files = {
                        'Database.txt': databaseFile,
                        'Names.txt': namesFile
                    };
                    generateZipFile(folderName, files, true);
                    self.$_showAddPointOfInterest('Archivo descargado correctamente');
                } else {
                    self.$_showDeleteGeofences('No hay archivos para descargar');
                }
                this.$set(item, 'isDownloading', false);
            })
            .catch(error => {
                if (error && error['status'] !== 200) {
                    self.$_showParameterError('No se pudo descargar el archivo');
                }
                this.$set(item, 'isDownloading', false);
            });
    }

    modalCreateDatabaseVisibility(value) {
        this.showModalCreateDatabase = value;
    }

    backToNormas() {
        this.$router.push(NAME_ROUTES.NORMAS.path);
    }

    modifyDatabaseName(){
        if(this.databaseRowToEdit !== -1){
            this.pendingRequest = true;
            let dbData: PatchDatabase = {
                id: this.items[this.databaseRowToEdit]['id'],
                description: this.databaseDescription
            }
            NormsServices.patchDatabaseName(
                dbData
            ).then((res) => {
                this.updateDbNameInTable();
                this.$_successDeleteRecipients(res.data.message);
                this.pendingRequest = false;
            }).catch((error) => {
                this.pendingRequest = false;
                this.cancelInlineEdition();
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo modificar el nombre del Database'
                });
            })
        }
    }

    updateDbNameInTable(){
        this.$set(this.items[this.databaseRowToEdit], 'description', this.databaseDescription);
        this.cancelInlineEdition();
    }

    cancelInlineEdition(){
        if(this.databaseRowToEdit !== -1){
            this.databaseDescription = '';
            this.databaseRowToEdit = -1;
            this.editedItem = this.defaultEditedItem;
        }
    }

    rowClicked(item){
        let currentIndexClicked = this.items.findIndex(it => it['id'] == item['id'])
        if(currentIndexClicked !== this.databaseRowToEdit){
            this.cancelInlineEdition()
        }
    }

    doubleClickRow(event, item){
        this.cancelInlineEdition();
        let rowClicked = item['item'];
        this.databaseDescription = rowClicked['description'];
        this.databaseRowToEdit = this.items.findIndex(it => it['id'] == rowClicked['id']);
        this.editedItem = Object.assign({}, rowClicked)
    }

    createFile() {
        this.customDatabaseData = null;
        this.previewDatabaseData = null;
        this.modalCreateDatabaseVisibility(true);
    }

    createFileFromThis(file) {
        let self = this;
        this.$set(file, 'createFromThis', true);
        NormsServices.getDatabaseDetail(file['id'])
            .then(response => {
                self.customDatabaseData = response;
                self.previewDatabaseData = null;
                self.modalCreateDatabaseVisibility(true);
                this.$set(file, 'createFromThis', false);
            })
            .catch(error => {
                self.customDatabaseData = null;
                self.previewDatabaseData = null;
                this.$set(file, 'createFromThis', false);
            });
    }

    previewFile(item) {
        this.$set(item, 'isLoading', true);
        let self = this;

        NormsServices.getDatabasePreviewByID(item['id'])
            .then(response => {
                let previewData = response;
                previewData['description'] = item['description'];
                self.previewDatabaseData = previewData;
                self.customDatabaseData = null;
                self.modalCreateDatabaseVisibility(true);
                self.$set(item, 'isLoading', false);
            })
            .catch(error => {
                self.customDatabaseData = null;
                self.$set(item, 'isLoading', false);
                self.previewDatabaseData = null;
                let msg = '';
                if (error && error.response && error.response.data && error.response.data.message) {
                    msg = error.response.data.message;
                } else {
                    msg = 'Ocurrió un error al obtener el preview';
                }
                this.$_errorAddPointOfInterest(msg);
            });
    }

    deleteDatabase(item) {
        this.dbToDelete = Number(item['id']);
        this.showDeleteConfirmationDialog = true;
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }
}
